import { empApi } from "./client";

// =============================================================
// API Quản lý bán hàng (góc nhìn quản lý) - FEv1 cổng nhân viên.
// Danh sách + chi tiết giao dịch của nhân viên cấp dưới. BE lọc theo token.
// =============================================================

// Booking
export const getBookingManagerListApi = (params) => empApi.get("/booking/app/manager", params);
export const getBookingManagerDetailApi = (id) => empApi.get(`/booking/app/manager/${id}`);

// Locking
export const getLockingManagerListApi = (params) => empApi.get("/locking/app/manager", params);
export const getLockingManagerDetailApi = (id) => empApi.get(`/locking/app/manager/${id}`);
// Thống kê locking (tổng danh số / tiền đặt cọc) -> { total, priceTotal, priceForCommissionTotal }
export const getLockingManagerStatisticApi = (params) =>
  empApi.get("/locking/app/managerStatistic", params);

// TTKQ
export const getTtkqManagerListApi = (params) => empApi.get("/ttkq/app/manager", params);
export const getTtkqManagerDetailApi = (id) => empApi.get(`/ttkq/app/manager/${id}`);

// Hợp đồng mua bán
export const getSalesContractManagerListApi = (params) => empApi.get("/salesContract/app/manager", params);
export const getSalesContractManagerDetailApi = (id) => empApi.get(`/salesContract/app/manager/${id}`);
export const getSalesContractManagerStatisticApi = (params) =>
  empApi.get("/salesContract/app/managerStatistic", params);
